import { setComma } from '~/utils/numberFormat'

/** @description
 * 페이징이 있는 리스트 api의 베이스 모델
 */
export class ListBaseModel {
  private _totalCount: string
  private _viewCount: string

  constructor (totalCount: string, viewCount?: string) {
    this._totalCount = totalCount
    this._viewCount = viewCount || totalCount
  }

  /** @description
   * 총 개수
   */
  get totalCount (): number {
    return parseInt(this._totalCount)
  }

  /** @description
   * 컴마 처리된 총 개수 (테이블 상단 문구 등에 사용)
   */
  get formattedTotalCount (): string {
    return setComma(this._totalCount)
  }

  /** @description
   * 실제 페이징 처리되는 개수
   * 데이터가 많을 시 전체 대신 최근 n개까지 보여주기 위하여 사용
   */
  get viewCount (): number {
    return parseInt(this._viewCount)
  }

  /** @description
   * 컴마 처리된 페이징 처리되는 개수 (테이블 상단 문구 등에 사용)
   */
  get formattedViewCount (): string {
    return setComma(this._viewCount)
  }
}